export type CurrencyCode = 'KRW' | 'USD';

export const extractDigits = (raw: string) => raw.replaceAll(/[^0-9]/g, '');

export const parseCurrencyNumber = (raw: string) => {
  const digits = extractDigits(raw);
  if (!digits) return 0;
  const n = Number(digits);
  return Number.isFinite(n) ? n : 0;
};

export const formatCurrencyInput = (raw: string, currency: CurrencyCode) => {
  const digits = extractDigits(raw);
  if (!digits) return '';
  const n = Number(digits);
  if (!Number.isFinite(n)) return '';
  const formatted = n.toLocaleString('en-US');
  return currency === 'KRW' ? `${formatted}원` : `$${formatted}`;
};

export const formatKoreanCurrency = (value: number) => {
  if (!Number.isFinite(value) || value <= 0) return '';
  const units = [
    { value: 1e12, label: '조' },
    { value: 1e8, label: '억' },
    { value: 1e4, label: '만' },
  ];
  let remaining = Math.floor(value);
  const parts: string[] = [];

  for (const unit of units) {
    const part = Math.floor(remaining / unit.value);
    if (part > 0) {
      parts.push(`${part.toLocaleString('ko-KR')}${unit.label}`);
      remaining %= unit.value;
    }
  }

  if (parts.length === 0) {
    return `${remaining.toLocaleString('ko-KR')}원`;
  }

  if (remaining > 0) {
    parts.push(`${remaining.toLocaleString('ko-KR')}`);
  }

  return `${parts.join(' ')}원`;
};
